module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft8.21bdae5c.jpg";